/**
 * Veluna Ritual Copy - Centralized Copy Module
 * Single source of truth for all "Ritual Completion Bonus" text strings
 * 
 * Usage:
 *   const copy = window.VelunaRitualCopy.bonus.exitIntent.headline;
 */

(function() {
  'use strict';

  window.VelunaRitualCopy = {
    bonus: {
      name: "Ritual Completion Bonus",
      
      // Optional microcopy for quiz page
      quizMicrocopy: "Complete your ritual to unlock your personalized guide.",
      
      // Exit intent modal copy (SAVE PROGRESS ONLY - no guest option)
      exitIntent: {
        headline: "Save your progress",
        body: "We'll save where you left off and email your personalized results when you're ready. Complete the quiz to get your saved Ritual Guide by email.",
        emailPlaceholder: "Enter your email",
        primaryCTA: "Save Progress",
        secondaryLink: "Continue Quiz"
      },
      
      // Results page bonus status messages
      results: {
        unlocked: "Guide sent - check your inbox.",
        noEmail: "Get your saved Ritual Guide by email."
      },
      
      // My Ritual page gate (has guest option)
      myRitualGate: {
        primaryCTA: "Email me my guide",
        guestCTA: "Continue as guest (view now)"
      },
      
      // Unlock modal states (has guest option) - mirrors Results gate
      unlockModal: {
        headline: "Email me my guide",
        body: "We'll email your complete Ritual Guide and save it for you.",
        emailPlaceholder: "Enter your email",
        primaryCTA: "Email me my guide",
        guestCTA: "Continue as guest (view now)",
        alreadyUnlocked: "Already unlocked",
        alreadyUnlockedMessage: "Guide sent - check your inbox."
      },
      
      // Unlock guide pop-up copy (legacy - kept for backward compatibility)
      unlockGuide: {
        headline: "Unlock Your Ritual Guide",
        supportingLine: "Get your saved Ritual Guide by email with step-by-step protocols, timing recommendations, and personalized insights."
      }
    }
  };

  // Console log for verification (dev mode only)
  if (localStorage.getItem('veluna_debug') === 'true' || window.VELUNA_DEBUG === true) {
    console.log('[VelunaRitualCopy] Module loaded:', window.VelunaRitualCopy);
  }
})();
